define(function(require) {
	// general
	const CommonReviewCode = require('civicsViews/assign_review/common/common');
	const CN = require('civicsUtils/constants');
	const ViewManager = require('civicsUtils/view_manager');
	// models
	const CdrLogModel = require('civicsModels/cdr_log_model');
	const ReviewModel = require('civicsModels/review_model');
	// collections
	const ServiceProvidersCollection = require('civicsCollections/service_providers_collection');
	// templates
	const tpl = require('civicsViews/assign_review/templates/t_itv_assign_review.hbs');
	// constants
	const REVIEW_STATE = CN.REVIEW_STATE();
	//utilities
	const AvailableFeatures = require('civicsUtils/available_features');

	return Marionette.ItemView.extend({
		initialize: function(options) {
			// if(__DEV__) console.log('review -- initialize');
			this.options = options;
			this.modalRegion = options.modalRegion;
			this.config = options.config;
			this.model = options.model;
			this.parentView = options.parentView;
			this.config.REVIEW_STATE = REVIEW_STATE;
			this.collection = options.serviceProviders;

			this.dataId = Number(this.model.get('assignedToProvider.id'));
		},
		onRender:function(){
			// if(__DEV__) console.log('review -- onRender');
			this.inputChanged();
			this.$el.rhythmThemeInit();

			// hide all error messages
			ViewManager.resetErrorMessages(this);
		},
		onShow:function(){
			// if(__DEV__) console.log('review -- onShow');
			this.inputChanged();
		},
		template: tpl,
		events: {
			'click @ui.btnCancel': 'cancelClicked',
			'click @ui.btnClose': 'closeClicked',
			'click @ui.btnSubmitRequest': 'submitRequestClicked',
			'droppyChange @ui.providersBox': 'inputChanged'
			},
		ui:{
			btnCancel:'.btn-cancel',
			btnClose:'.bbm-btn-close',
			btnSubmitRequest:'.btn-submit-request',
			dayPhone: '.day-phone',
			mobilePhone: '.mobile-phone',
			emailAddress: '.email-address',
			providers: '#providers',
			providersBox: '.field.assign-review .droppy',
			modal: '#assign-review-modal-content'
		},
		enableButtons: function(enable){
			$(this.ui.btnCancel).prop('disabled', !enable);
			$(this.ui.btnClose).prop('disabled', !enable);
			$(this.ui.btnSubmitRequest).prop('disabled', !enable);
		},
		inputChanged: function(data){
			if(__DEV__) console.log('review -- providerChanged');

			if(this.collection){
				// Fill in items for Phone and Email based on selection
				this.dataId = data ? data.result.data : this.dataId;
				let providers = this.collection.where({id:Number(this.dataId)});

				if (providers.length == 1) {
					ViewManager.resetErrorMessages(this);
					this.ui.dayPhone.text(providers[0].get('dayPhone'));
					this.ui.mobilePhone.text(providers[0].get('mobileNumber'));
					this.ui.emailAddress.text(providers[0].get('eMailAddress'));
				} else {
					this.ui.dayPhone.text("");
					this.ui.mobilePhone.text("");
					this.ui.emailAddress.text("");
				}
			}
			
		},
		cancelClicked:function(){
			if(__DEV__) console.log('review -- cancelClicked');
			this.triggerMethod('cancelAssignReview:clicked');
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		closeClicked:function(){
			if(__DEV__) console.log('review -- closeClicked');
			this.triggerMethod('closeAssignReview:clicked');
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		submitRequestClicked:function(){
			if(__DEV__) console.log('review -- submitRequestClicked');
			this.enableButtons(false);
			var self = this;

			// hide all error messages
			ViewManager.resetErrorMessages(self);

			var data = ViewManager.fromWindow(self);

			// Assigned To Provider is required
			if (self.dataId == null || self.dataId <= 1) {
				var error = {};
				error.validationError = {};
				error.validationError.providers = i18n.t('CIVICS.COMMON.ASSIGN_TO_REQ');
				ViewManager.errorToWindow(error, $(self.ui.modal));
				self.enableButtons(true);
				return;
			}

			var reviewModel = new ReviewModel();
			reviewModel.set({id: self.model.get('id')});
			reviewModel.set({'assignedToProvider':{id:Number(self.dataId)}});
			reviewModel.formatUrlRoot(self.config.fromServer.instrumentType);
			reviewModel.unset("attachments", {silent: true});			//Do not send Attachments, there is no need to since we can't update them.
			reviewModel.unset("reviewAttachments", {silent: true});

			reviewModel.save(null, {
				error: function(model, response, options) {
					ViewManager.errorToWindow(response, self.ui.providers);
					self.enableButtons(true);
				}
			})
			.done(function(response, status, xhrResponse) {
				ViewManager.broadcast(self,'saved');
				if(__DEV__) console.log('review -- done function after save model');
				self.triggerMethod('submitAssignReview:clicked', response.data);

				if(self.parentView){
					self.parentView.reviewAssigned(response.data);
				} else {
					self.triggerMethod('reviewAssigned');
				}

				if(self.modalRegion) {
					self.modalRegion.hideModal();
				}
				else {
					self.destroy();
				}
			})
			.fail(function(response, status, xhrResponse){
				ViewManager.errorToWindow(response);
				self.enableButtons(true);
			});
		},
		hasServiceProviders: function(){
			if(this.collection)
				return this.collection.length > 0;
			
			return false;
			
		},
		templateHelpers: function() {
			var self = this;
			var helpers = {
				serviceProvidersCollection: function(){
					var cmp = function(a, b) {
							if (a > b) return +1;
							if (a < b) return -1;
							return 0;
						};
						var sp = self.collection.toJSON().sort(function(a,b){
							if(a.identity && b.identity){
								return cmp(a.identity.lastName.toLowerCase(), b.identity.lastName.toLowerCase())
								|| cmp(a.identity.firstName.toLowerCase(),b.identity.firstName.toLowerCase());
							}
							return 0;
						});
						return sp;
				},
				showMobileNumber: AvailableFeatures.DisplayMobileNumber(),
				phoneLabel: AvailableFeatures.DisplayMobileNumber() ? i18n.t('CIVICS.COMMON.ALTERNATE_PHONE') : i18n.t('CIVICS.COMMON.PHONE'),
				hasServiceProviders: function () {
					return self.hasServiceProviders();
				},
				concatDroppyOption: function(firstName,lastName) {
					if(firstName){
						return firstName+' '+lastName;
					}else{
						return lastName;
					}
				}
			};

			// Add the common helpers
			_.extend(helpers, CommonReviewCode.commonHelpers(this));
			return helpers;
		}
	});
});
